import React from 'react';
import { Trans } from '@lingui/react/macro';
import theme from './ReadyToggleCard.module.scss';
import { Checkbox } from '@ygtechnologies/rubus-ui';

interface ReadyToggleCardProps {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    title?: string;
    subtitle?: string;
    disabled?: boolean;
    className?: string;
    width?: string;
}

const ReadyToggleCard: React.FC<ReadyToggleCardProps> = ({
    checked,
    onChange,
    title,
    subtitle,
    disabled = false,
    className = '',
    width = '284px',
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(e.target.checked);
    };

    return (
        <div className={`${theme.readyToggleCard} ${checked ? theme.checked : ''} ${className}`} style={{ width: width }}>
            <div className={theme.checkboxContainer}>
                <Checkbox checked={checked} onChange={handleChange} disabled={disabled} />
            </div>
            <div className={theme.readyText}>
                <div className={theme.readyTitle}>{title || <Trans>Ready to send offer?</Trans>}</div>
                <div className={theme.readySubtitle}>{subtitle || <Trans>Click on the checkbox</Trans>}</div>
            </div>
        </div>
    );
};

export default ReadyToggleCard;
